import React from 'react';
import './index.sass';
import OfferItem from "./OfferItem";

// Inline SVG-иконки в фирменном стиле (вместо старых растровых SVG)
const IconStrategy = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 3v18h18" /><path d="M7 14l3-3 3 3 5-6" />
  </svg>
);
const IconCode = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="16 18 22 12 16 6" /><polyline points="8 6 2 12 8 18" />
  </svg>
);
const IconLayers = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="12 2 2 7 12 12 22 7 12 2" /><polyline points="2 17 12 22 22 17" /><polyline points="2 12 12 17 22 12" />
  </svg>
);
const IconData = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <ellipse cx="12" cy="5" rx="9" ry="3" /><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" /><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
  </svg>
);
const IconShield = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="M9 12l2 2 4-4" />
  </svg>
);
const IconSupport = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><path d="M12 6v6l4 2" />
  </svg>
);

export const OFFERS_LIST = [
    {
        icon: <IconStrategy />,
        title: 'Архитектура и ИТ-стратегия',
        description: 'Проектируем целевую архитектуру сложных систем и экосистем: домены, подсистемы, ядра и интеграционные контуры. Помогаем пройти путь от идеи к промышленной эксплуатации.'
    },
    {
        icon: <IconCode />,
        title: 'Сложная продуктовая разработка',
        description: 'Web, desktop и mobile высокой нагрузки. Команды полного цикла — от проектирования доменных моделей до релизов и развития продукта годами.'
    },
    {
        icon: <IconLayers />,
        title: 'Платформы и экосистемы',
        description: 'Создаём многоканальные платформы: личные кабинеты, операционные контуры, оркестрация сервисов, мониторинг и управление — единый рабочий контур.'
    },
    {
        icon: <IconData />,
        title: 'Данные и аналитика',
        description: 'Корпоративные хранилища, аналитические системы, семантические графы и ИИ-модели. Превращаем данные управленцев в работающие решения.'
    },
    {
        icon: <IconShield />,
        title: 'Информационная безопасность',
        description: 'Соответствие требованиям регуляторов, ролевые модели, аудит и контроль доступа. Безопасность закладывается в архитектуру, а не добавляется потом.'
    },
    {
        icon: <IconSupport />,
        title: 'Сопровождение 24/7',
        description: '2-я и 3-я линия поддержки критичных систем. SLA, мониторинг, инцидент-менеджмент — системы под нашей опекой работают без сюрпризов.'
    }
]


const Offer = () => {
    return (
        <section className="Offer" id="offer">
            <div className="container container--slim">
                <div className="Offer__Head">
                    <span className="Offer__Eyebrow">Что мы делаем</span>
                    <h2 className='Offer__Title'>
                        Берёмся за задачи <span className="Text-Accent">высокой сложности</span>
                    </h2>
                    <p className="Offer__Lead">
                        Мы не делаем «быстрых сайтов». Мы строим системы, которые живут в эксплуатации
                        годами, выдерживают рост нагрузок и меняются вместе с бизнесом заказчика.
                    </p>
                </div>

                <div className='Offer__List'>
                    {
                        OFFERS_LIST.map(({icon, title, description}) => (
                            <OfferItem icon={icon} title={title} description={description} key={title}/>
                        ))
                    }
                </div>
            </div>
        </section>
    );
};

export default Offer;
